var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    { staticClass: "eu-fade-in !mt-6 !mb-3" },
    [
      _c(
        "form",
        {
          ref: "boxForm",
          attrs: { action: "javascript:void(0)", novalidate: "true" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c("jade-group-header", {
            attrs: { title: _vm.title },
            scopedSlots: _vm._u([
              {
                key: "trailing",
                fn: function () {
                  return [
                    _vm.showButtonEdit
                      ? _c(
                          "jade-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.disabled,
                                expression: "disabled",
                              },
                            ],
                            attrs: {
                              icon: "action-edit",
                              size: "small",
                              variant: "primary-ghost",
                            },
                            on: { click: _vm.handleClickEditBtnEdit },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.edit")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "eu-pa_6 eu-align_center" },
                [_c("jade-spinner")],
                1
              )
            : _c(
                "div",
                { staticClass: "flex flex-col gap-5" },
                [
                  (_vm.showAlert && !_vm.hiddenAlert) || _vm.showAlertInfo
                    ? _c(
                        "div",
                        { staticClass: "mx-5" },
                        [
                          _vm.showAlert && !_vm.hiddenAlert
                            ? _c(
                                "jade-alert",
                                {
                                  attrs: {
                                    variant: _vm.formError
                                      ? "negative"
                                      : "positive",
                                    showIcon: "",
                                    title: _vm.formError
                                      ? _vm.$t(
                                          "account.settings.alert.error-title"
                                        )
                                      : _vm.$t(
                                          "account.settings.alert.success-title"
                                        ),
                                    onDismiss: true,
                                  },
                                  on: { onDismiss: _vm.closeAlert },
                                },
                                [
                                  _vm.formError
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.errors,
                                          function (error, index) {
                                            return _c("p", { key: index }, [
                                              _vm._v(" " + _vm._s(error) + " "),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.saved-success"
                                            )
                                          )
                                        ),
                                      ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.showAlertInfo
                            ? _c(
                                "jade-alert",
                                {
                                  attrs: {
                                    showIcon: "",
                                    variant: "info",
                                    title: _vm.$t(
                                      "account.settings.alert.info-title"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "account.settings.alert.info-content"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    _vm.as,
                    { tag: "component", attrs: { disabled: _vm.disabled } },
                    [
                      _c("legend", { staticClass: "eu-display_none" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _c("div", { staticClass: "p-5" }, [_vm._t("content")], 2),
                      _vm.hasPassword
                        ? _c(
                            "div",
                            [
                              _c("hr", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.disabled,
                                    expression: "!disabled",
                                  },
                                ],
                                staticClass: "emd-divider m-5 mt-0",
                              }),
                              _c("password-confirmation", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.disabled,
                                    expression: "!disabled",
                                  },
                                ],
                                staticClass: "px-5",
                                model: {
                                  value: _vm.password,
                                  callback: function ($$v) {
                                    _vm.password = $$v
                                  },
                                  expression: "password",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
          _vm.isEditable
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled,
                      expression: "!disabled",
                    },
                  ],
                  staticClass: "flex justify-end gap-3 p-4 pt-0",
                },
                [
                  _c(
                    "jade-button",
                    {
                      attrs: {
                        variant: "neutral-ghost",
                        type: "button",
                        disabled: _vm.isLoading,
                      },
                      on: { click: _vm.cancelEdit },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("account.settings.cancel")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "jade-button",
                    {
                      attrs: {
                        variant: "primary-solid",
                        tabindex: "0",
                        type: "submit",
                        disabled: _vm.submitButtoniIsDisabled,
                      },
                    },
                    [
                      _vm.submitButtoniIsLoading
                        ? _c("jade-spinner")
                        : _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("account.settings.save-updates"))
                            ),
                          ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.hasConfirm
        ? _c("emd-confirm", {
            ref: "confirmModal",
            attrs: { message: _vm.messageConfirm },
            on: { confirm: _vm.submitConfirm },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }